import { Component, OnInit, ViewChildren, AfterViewInit, OnDestroy, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatSort, Sort } from '@angular/material/sort';
import { DataSource } from '@angular/cdk/collections';
import { merge, Observable, BehaviorSubject, Subscription } from 'rxjs';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ResponsiveService } from '../../../../../../core/services/responsive.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import {EnumSignMethod} from "../../../../../../core/constants/contract";
import { TruncatePipe } from 'src/app/shared/pipe/TruncatePipe';

@Component({
  selector: 'app-dialog-sync-digital-certificate',
  templateUrl: './dialog-sync-digital-certificate.component.html',
  styleUrls: ['./dialog-sync-digital-certificate.component.scss']
})
export class DialogSyncDigitalCertificateComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalServiceType: number;
  isReadySignEkyc: boolean;
  isReadySignEkycAdvanced: boolean;
  widthHeadCofig = '';
  quantityEkycInfo = {
    ekycQuantity: 0,
    advanceEkycQuantity: 0,
    isBoughtEkyc: true,
    isBoughtEkycAdvanced: true
  };
  checkAll: boolean;
  dataSelected: Map<any, DigitalCertificates> = new Map<any, DigitalCertificates>();

  displayedFirstColumns: string[] = [];
  firstColumnDefinitions = [
    { def: 'id', showMobile: true },
    { def: 'typeCertificate', showMobile: true },
    { def: 'issuedTo', showMobile: true },
    { def: 'serialNumber', showMobile: true },
    { def: 'taxCode', showMobile: true },
    { def: 'phoneNumber', showMobile: true },
    { def: 'status', showMobile: true },
    { def: 'status_sync', showMobile: true },
  ];

  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: 'check', showMobile: true, show: true },
    { def: "id",showMobile: true, show: true},
    { def: "typeCertificate", showMobile: true, show: true },
    { def: "issuedTo", showMobile: true, show: true },
    { def: "serialNumber", showMobile: false, show: true },
    { def: "taxCode", showMobile: false, show: true },
    { def: "phoneNumber", showMobile: false, show: true },
    { def: "activeDate", showMobile: false, show: true },
    { def: "expireDate", showMobile: false, show: true },
    { def: "status", showMobile: true, show: true },
    { def: "status_sync", showMobile: true, show: true },
  ]

  digitalCertificate = new DigitalCertificate();
  parentDigitalCertificates: DigitalCertificates[];
  childOldDataList: DigitalCertificateKeyPair = {};
  childPaginateList: PaginateKeyPair = {};
  childSortList: SortKeyPair = {};
  childIsExpanding: Array<string>;
  paginate: {
    currentPage: number;
    pageSize: number;
    totalRow: number;
    totalPage: number;
    totalPageArray: any;
    no: any;
  };
  tplModal: NzModalRef;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table

  checkNote: any;

  @BlockUI() blockUI: NgBlockUI;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isHsmPermission: boolean = false
  userType: any;
  certificateType = EnumSignMethod;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogSyncDigitalCertificateComponent>,
    public digitalCertificateService: DigitalCertificateService,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onBtnCancelClick();
    });
  }

  ngOnInit() {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };
    this.userType = localStorage.getItem('userType');

    this.digitalCertificate = {
      search: '',
      typeCertificate: 'null',
      syncStatus: 'NOT_SYNCED'
    };

    this.loadDataForFirstTime();
    this.checkConfigureDisplayed();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
          this.getDisplayedFirstColumns();
        }
      }
    );
  }
  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }
  getDisplayedFirstColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedFirstColumns = this.firstColumnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedFirstColumns = this.firstColumnDefinitions.map(cd => cd.def);
    }
  }


  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.show)
        .map(cd => cd.def);
      console.log('this.displayedColumns', this.displayedColumns);
      
    }
  }

  onColumnDefinitionsChange(configureDisplayed: any) {
    this.columnDefinitions.forEach(element => {
      if (configureDisplayed.data.includes(element.def)) {
        element.show = false;
      } else {
        element.show = true;
      }
    });
    this.widthHeadCofig = `${(configureDisplayed.count + 2) * 90}px`;
    this.getDisplayedColumns();
  }

  checkConfigureDisplayed() {
    if (localStorage.getItem('configureDisplayed')) {
      const configureDisplayed = JSON.parse(localStorage.getItem('configureDisplayed'));
      this.onColumnDefinitionsChange(configureDisplayed);
    }
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize
    };

    this.onFilterData();
  }

  loadDataForFirstTime() {
    this.digitalCertificateService.filterSyncDigitalCertificates(
      {
        ...this.digitalCertificate,
        ...this.paginate,
        page: this.paginate.currentPage,
      }
    ).subscribe(result => {
      console.log('result onFilterData --', result);
      result.data.dataRow.forEach(async(row) => {
        if(row.syncStatus === 'SYNCED')
        row.syncStatusMessage = await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_synced');
        else if (row.syncStatus === 'NOT_SYNCED')
        row.syncStatusMessage =  await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_not_synced');

      });
      this.dataSource.data = result.data.dataRow;

      if (result.data.dataRow) {
        this.checkNote = result.data.dataRow.filter((data: any) => data && data.type == 2);
      }

      this.isReadySignEkyc = result.allowEkyc;
      this.isReadySignEkycAdvanced = result.allowAdvanceEkyc;
      this.totalServiceType = result.totalRow;
      this.paginate = {
        ...this.paginate,
        currentPage: result.data.currentPage,
        pageSize: result.data.pageSize,
        totalRow: result.data.totalRow,
        totalPage: Math.ceil(result.data.totalRow / result.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(result.data.totalRow / result.data.pageSize), 1),
        no: this.commonService.counter(result.data.pageSize, result.data.currentPage * result.data.pageSize + 1)
      };

      this.initParent(result);
      this.checkCheckAll();
    });

    this.digitalCertificateService.getPermissionHSM(localStorage.getItem('enterpriseId')).subscribe(res => {
      if(res && res.success){
        this.isHsmPermission = res.data.enableHsm
        if(!this.isHsmPermission){
          this.digitalCertificateService.checkHsmPermission().subscribe(rs => {
            if(rs && rs.success){
              this.isHsmPermission = rs.data;
            }
          })
        }
      }
    })
  }

  onFilterData() {
    this.digitalCertificateService.filterSyncDigitalCertificates(
      {
        ...this.digitalCertificate,
        ...this.paginate,
        page: this.paginate.currentPage,
      }
    ).subscribe(result => {
      console.log('result onFilterData --', result);
      result.data.dataRow.forEach(async(row) => {
        if(row.syncStatus === 'SYNCED')
        row.syncStatusMessage = await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_synced');
        else if (row.syncStatus === 'NOT_SYNCED')
        row.syncStatusMessage =  await this.commonService.getMessage('system_document_template.cbx_document_status.cbx_document_status_not_synced');
        console.log(row, 'row')
      });
      this.dataSource.data = result.data.dataRow;

      if (result.data.dataRow) {
        this.checkNote = result.data.dataRow.filter((data: any) => data && data.type == 2);
      }

      this.isReadySignEkyc = result.allowEkyc;
      this.isReadySignEkycAdvanced = result.allowAdvanceEkyc;
      this.totalServiceType = result.totalRow;
      this.paginate = {
        ...this.paginate,
        currentPage: result.data.currentPage,
        pageSize: result.data.pageSize,
        totalRow: result.data.totalRow,
        totalPage: Math.ceil(result.data.totalRow / result.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(result.data.totalRow / result.data.pageSize), 1),
        no: this.commonService.counter(result.data.pageSize, result.data.currentPage * result.data.pageSize + 1)
      };

      this.initParent(result);
      this.checkCheckAll();
    });
  }

  onClickBtnFilter() {
    this.onFilterData();
  }

  public onSelectionChange(element) {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  checkCheckAll() {
    let data = [...this.dataSource.data]
    for (let i = 0; i < data.length; i++) {
      const currentRow = data[i];
      if (!this.dataSelected.has(currentRow.id)) {
        this.checkAll = false;
        break;
      }
      if (i === data.length - 1) {
        this.checkAll = true;
      }
    }
  }

  public checkAllDocument() {
    this.dataSource.data.forEach(data => {
      data.checked = this.checkAll;
      this.dataSelected.set(data.id, data);
      if (!this.checkAll) {
        this.dataSelected.delete(data.id);
      }
    });
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;
    this.parentDigitalCertificates = rs.data.dataRow;

    this.parentDigitalCertificates.forEach(parent => {
      parent['STT'] = stt++;
      this.childPaginateList[parent.id] = new Paginate();
      this.childOldDataList[parent.id] = new DigitalCertificates();
      this.childSortList[parent.id] = new MatSort();
    });
    this.countDataSelected()
    this.initDataSelected();
    this.dataSource.data = this.parentDigitalCertificates;
    this.childIsExpanding = []; // close all parent
  }

  countDataSelected() {
    const dataSelectedClone = this.dataSelected
    this.dataSelected = new Map<any, DigitalCertificates>()
    
    for (let i = 0; i < this.parentDigitalCertificates.length; i++) {
      if (dataSelectedClone.has(this.parentDigitalCertificates[i].id)) {        
        this.dataSelected.set(this.parentDigitalCertificates[i].id, this.parentDigitalCertificates[i])
      }
    }    
  }

  initDataSelected() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    for (let i = 0; i < this.parentDigitalCertificates.length; i++) {
      if (this.dataSelected.has(this.parentDigitalCertificates[i].id)) {
        this.parentDigitalCertificates[i].checked = true;
      } else {
        this.parentDigitalCertificates[i].checked = false;
      }
    }

    for (let i = 0; i < this.parentDigitalCertificates.length; i++) {
      if (!this.dataSelected.has(this.parentDigitalCertificates[i].id)) {
        this.checkAll = false;
        break;
      }
      if (i === this.parentDigitalCertificates.length - 1) {
        this.checkAll = true;
      }
    }
  }

  synchronizeSelectedRecords() {
    let arrIds = []
    this.dataSelected.forEach(e => {
      arrIds.push(e.id)
    })
    const dataSync = {
      ids: arrIds,
      type: null
    }
    this.synchronizeServiceAction(dataSync)
  }

  synchronizeAll() {
    const dataSync = {
      type: "ALL",
      filter: {
        ...this.digitalCertificate,
        ...this.paginate,
      }
    }
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.sync_digital_certificate'), this.paginate.totalRow)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.synchronizeServiceAction(dataSync)
      }
      dialogRe.close();
    });
  }

  synchronizeServiceAction(data) {
    this.digitalCertificateService.syncDigitalCertificates(data).subscribe(res => {
      // console.log(res);
      if (res && res.success) {
        this.toastr.success(this.commonService.format(
          this.message.getMessage('messages.sync_digital_certificate_success'), res.data.done, parseInt(res.data.done) + parseInt(res.data.failed)))
        setTimeout(() => {
          this.closeDialog(true)
        }, 500);
      } else {
        this.toastr.error(res.message)
        this.onFilterData();
      }
    })
  }

  onBtnCancelClick() {
    // const dialogRe = this.dialog.open(WarningComponent, {
    //   width: '350px',
    //   data: this.message.getMessage('messages.confirm_change_data')
    // });
    // dialogRe.afterClosed().subscribe(rs => {
    //   if (rs) {
    //     this.closeDialog()
    //   }
    //   dialogRe.close();
    // });
    this.closeDialog(false)
  }

  closeDialog(isChange: boolean) {
    this.dialogRef.close(isChange);
    this.dataSelected.clear()
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };
    this.digitalCertificate = {
      search: '',
      typeCertificate: undefined,
      syncStatus: 'NOT_SYNCED'
    };
    this.dataSource = new MatTableDataSource();
  }

}

export class DigitalCertificate {
  typeCertificate: any = 'null';
  search: any
  syncStatus: string
}

export class DigitalCertificates {
  id: string;
  idDetail: string;
  enterpriseId: string;
  enterpriseName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  isDeleted: boolean;
  typeCertificate: any = 'null';
  phoneNumber: string;
  filePath: string;
  issuedTo: string;
  certificateStatus: number;
  syncStatus: string
  checked: boolean
}

export class DigitalCertificateKeyPair {
	[key: string]: DigitalCertificates;
}

export class PaginateKeyPair {
	[key: string]: Paginate;
}

export class SortKeyPair {
	[key: string]: MatSort;
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}
